import { RefundMethodsPage } from './v2/refund-methods.page'
import RefundMethodPage from './v1/refund-method.page'
import { useAppSelector } from '@/redux/hooks'

export const RefundMethodsPageEntry = () => {
  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  const refundMethodsResponse = useAppSelector(
    (store) => store.refundMethodsApi.refundMethods.response
  )

  const isKeepYourItemOffered =
    refundMethodsResponse.result?.refund_methods?.some(
      (method) => method.keep_your_item?.enabled === true
    )

  const isMisako = settings.ecommerce_group == 'misako'
  const isHoff = settings.ecommerce_group == 'hoff'

  if (!refundMethodsResponse.result_raw) {
    return null
  }

  return !isMisako && !isHoff && !isKeepYourItemOffered ? (
    <RefundMethodsPage />
  ) : (
    <RefundMethodPage />
  )
}
